import { remove as removeDiacritics } from 'diacritics'

export function isEmptyOrNull(word: string) {
	return !word || word.trim().length === 0
}

export function isInvalidAddress(address: string) {
	// eslint-disable-next-line no-useless-escape
	const validEmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	return !validEmailRegex.test(address)
}

export function isInvalidPassword(password: string) {
	const passwordRegex = /^[a-zA-Z0-9_.-]*$/
	return !passwordRegex.test(password)
}

export const isAplicacao = (() => {
	//modo de apresentacao
	if (process.env.NODE_ENV === 'staging') {
		return true
	}

	const parts = window.location.host.split('.')
	const domainLength = 3
	return parts.length !== domainLength - 1 && parts[0] !== 'www' && parts[1] !== 'cloudfront'
})()

export const navigationSubdomain = (() => {
	return window.location.host.split('.')[0]
})()

export const navigationDomain = (() => {
	return window.location.host.split('.')
})()


export const backendDomain = () => process.env.VUE_APP_BACKEND_API || '/api'

export const isVestcasa = navigationSubdomain.startsWith('vestcasa')

export const isIostec = navigationSubdomain.startsWith('iostec')

export const isSantaines = navigationSubdomain.startsWith('santaines')

export const isTexcotton = navigationSubdomain.startsWith('texcotton')

export const isMarcatto = navigationSubdomain.startsWith('marcatto')

export const isFormitz = navigationSubdomain.startsWith('formitz')

export const comparacaoDiatrica = (texto: string, substring: string) =>
	removeDiacritics(texto).toUpperCase().includes(removeDiacritics(substring).toUpperCase())

export const cores = [
	'red',
	'orange',
	'yellow',
	'primary',
	'blue',
]

export const ambiente = (() => {
	if (window.location.hostname.endsWith('.com') || window.location.hostname.endsWith('.br') || window.location.hostname.endsWith('.store')) {
		return 'Produção'
	} else if (window.location.hostname.endsWith('.dev')) {
		return 'Staging'
	} else if (window.location.hostname.endsWith('.it')) {
		return ''
	}
	return 'Máquina do DEV'
})()

export const nextTick = () => new Promise(resolve => setTimeout(() => resolve(undefined)))

export function validarCpf(cpf: string): boolean {
	const limpo = (cpf || '').replace(/[^\d]/g, '')
	if (limpo.length !== 11) return false
	if (/^(\d)\1+$/.test(limpo)) return false

	// Primeiro dígito verificador
	let soma = 0
	for (let i = 0; i < 9; i++) {
		soma += parseInt(limpo.charAt(i)) * (10 - i)
	}
	let resto = soma % 11
	let digito = resto < 2 ? 0 : 11 - resto
	if (digito !== parseInt(limpo.charAt(9))) return false

	// Segundo dígito verificador
	soma = 0
	for (let i = 0; i < 10; i++) {
		soma += parseInt(limpo.charAt(i)) * (11 - i)
	}
	resto = soma % 11
	digito = resto < 2 ? 0 : 11 - resto
	return digito === parseInt(limpo.charAt(10))
}

/**
 * Valida CNPJ numérico ou alfanumérico (IN RFB 2229/2024): os 12 primeiros
 * caracteres podem ser [A-Z0-9] e os 2 últimos (verificadores) são numéricos.
 */
export function validarCnpjAlfanumerico(cnpj: string): boolean {
	const limpo = (cnpj || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase()
	if (limpo.length !== 14) return false
	if (!/^[A-Z0-9]{12}\d{2}$/.test(limpo)) return false
	if (/^(.)\1+$/.test(limpo)) return false

	// Conversão: '0'-'9' → 0-9; 'A'-'Z' → 17-42 (charCode - 48), igual ao backend
	const valorDoChar = (c: string) => c.charCodeAt(0) - 48

	const calcularDigito = (qtdChars: number) => {
		let soma = 0
		let peso = 2
		for (let i = qtdChars - 1; i >= 0; i--) {
			soma += valorDoChar(limpo.charAt(i)) * peso
			peso = peso === 9 ? 2 : peso + 1
		}
		const resto = soma % 11
		return resto < 2 ? 0 : 11 - resto
	}

	const dig13 = calcularDigito(12)
	const dig14 = calcularDigito(13)
	return dig13 === Number(limpo.charAt(12)) && dig14 === Number(limpo.charAt(13))
}

export function validarCpfOuCnpj(cpfOuCnpj) {
	if (!cpfOuCnpj) return true

	const limpo = cpfOuCnpj.replace(/[^A-Za-z0-9]/g, '').toUpperCase()

	if (limpo.length === 11) return validarCpf(limpo)
	if (limpo.length === 14) return validarCnpjAlfanumerico(limpo)

	return false
}


